import { useRef as g, useState as T, useEffect as x } from "react";
import { useTagName as K, useEvent as C, useForkRef as M } from "../../../ariakit-react-utils/esm/hooks.js";
import { createHook as O, createComponent as P, createElement as U } from "../../../ariakit-react-utils/esm/system.js";
import { isButton as d, isTextField as h } from "../../../ariakit-utils/esm/dom.js";
import { isSelfTarget as q, queueBeforeEvent as H, fireClickEvent as S } from "../../../ariakit-utils/esm/events.js";
import { queueMicrotask as b } from "../../../ariakit-utils/esm/misc.js";
import { isFirefox as L } from "../../../ariakit-utils/esm/platform.js";
import { useFocusable as V } from "../focusable/focusable.js";
function D(n) {
  if (!n.isTrusted) return !1;
  const r = n.currentTarget;
  return d(r) || r.tagName === "SUMMARY" || r.tagName === "INPUT" || r.tagName === "TEXTAREA" || r.tagName === "A" || r.tagName === "SELECT";
}
const X = O((n) => {
  let {
    clickOnEnter: r = !0,
    clickOnSpace: s = !0,
    ...t
  } = n;
  const o = g(null), p = K(o, t.as), [A, R] = T(() => !!p && d({
    tagName: p,
    type: t.type
  }));
  x(() => {
    o.current && R(d(o.current));
  }, []);
  const [v, E] = T(!1), c = g(!1), k = "data-command" in t, u = t.onKeyDown, B = C((e) => {
    u == null || u(e);
    const i = e.currentTarget;
    if (e.defaultPrevented || k || t.disabled || !q(e) || h(i) || i.isContentEditable) return;
    const a = r && e.key === "Enter", m = s && e.key === " ", l = e.key === "Enter" && !r, I = e.key === " " && !s;
    if (l || I) {
      e.preventDefault();
      return;
    }
    if (a || m) {
      const N = D(e);
      if (a) {
        if (!N) {
          e.preventDefault();
          const {
            view: _,
            ...w
          } = e, y = () => S(i, w);
          L() ? H(i, "keyup", y) : b(y);
        }
      } else m && (c.current = !0, N || (e.preventDefault(), E(!0)));
    }
  }), f = t.onKeyUp, F = C((e) => {
    if (f == null || f(e), e.defaultPrevented || k || t.disabled || e.metaKey) return;
    const i = s && e.key === " ";
    if (c.current && i && (c.current = !1, !D(e))) {
      E(!1);
      const a = e.currentTarget, {
        view: m,
        ...l
      } = e;
      b(() => S(a, l));
    }
  });
  return t = {
    "data-command": "",
    "data-active": v ? "" : void 0,
    type: A ? "button" : void 0,
    ...t,
    ref: M(o, t.ref),
    onKeyDown: B,
    onKeyUp: F
  }, t = V(t), t;
}), Y = P((n) => (n = X(n), U("button", n)));
process.env.NODE_ENV !== "production" && (Y.displayName = "Command");
export {
  Y as Command,
  X as useCommand
};
//# sourceMappingURL=command.js.map
